import { useRef, useState, type FormEvent } from 'react';
import type { SessionUser } from '@qlkho-v3/shared';

import { api } from './api';
import { ArrowUpIcon, EyeIcon, EyeOffIcon, LogoMark } from './icons';

export function Login({ onSuccess }: { onSuccess: (user: SessionUser) => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const passwordInput = useRef<HTMLInputElement>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const result = await api<{ user: SessionUser }>('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ username, password, remember })
      });
      onSuccess(result.user);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Không thể đăng nhập.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login-page">
      <form className="login-form" onSubmit={submit}>
          <div className="login-brandline"><LogoMark /><b>KHO VTYT</b><em>V3</em></div>
          <h1>Đăng nhập</h1>
          <div className="field login-field">
            <label htmlFor="username">Tên đăng nhập</label>
            <input
              id="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="username"
              autoFocus
              placeholder="Nhập tên đăng nhập"
            />
          </div>
          <div className="field login-field">
            <label htmlFor="password">Mật khẩu</label>
            <div className="password-control">
              <input
                ref={passwordInput}
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
                placeholder="Nhập mật khẩu"
              />
              <button type="button" className="password-toggle" aria-label={showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'} aria-pressed={showPassword} title={showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'} onClick={() => { setShowPassword((current) => !current); passwordInput.current?.focus(); }}>
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>
          <label className="check-control">
            <input type="checkbox" checked={remember} onChange={(event) => setRemember(event.target.checked)} />
            <span>Giữ đăng nhập trên thiết bị này</span>
          </label>
          {error ? <div className="form-error" role="alert">{error}</div> : null}
          <button className="login-submit" disabled={submitting || !username || !password}>
            <span>{submitting ? 'Đang xác thực…' : 'Đăng nhập'}</span>
            {submitting ? <i className="button-spinner" /> : <ArrowUpIcon />}
          </button>
      </form>
    </main>
  );
}
